import React from "react";
import { useHistory } from "react-router-dom";
import {
  Row,
  Space,
  Badge,
  Dropdown,
  List,
  Typography,
  Button,
  Modal as ModalB,
  message,
} from "antd";
import Icon from "@mdi/react";
import { mdiLogout, mdiLockReset } from "@mdi/js";

import {
  BellOutlined,
  MenuOutlined,
  MailOutlined,
  UserOutlined,
} from "@ant-design/icons";

import { ExclamationCircleOutlined } from "@ant-design/icons";

//Firebase
import firebase from "../../utils/Firebase";
import "firebase/auth";

//Importaciones para el uso de Redux
import { useDispatch } from "react-redux";
import { updateUserAction } from "../../actions/userActions";
import { updateLoguedAction } from "../../actions/isLoguedActions";

//Imaganes y logos
import logo_title from "../../assets/img/logo-menu.png";
import { colorPrm } from "../../constants";

//Estilos
import "./Header.scss";
import curStyle from "../../css/GlobalCmp.module.css";

export default function Header(props) {
  const {
    setIsLoading,
    currentUser,
    openModal,
    curFecha,
    titleHeader,
    userOptions,
    openDrawer,
  } = props;

  const history = useHistory();

  //Ejecutar dispatch SEGUN BECESIDADES
  const dispatch = useDispatch();
  const updateData = (state) => dispatch(updateUserAction(state));
  const updateLogued = (state) => dispatch(updateLoguedAction(state));

  const { Title } = Typography;
  const { confirm } = ModalB;
  const curDate = new Date();

  const logOut = async () => {
    confirm({
      title: "CERRAR SESION",
      icon: <ExclamationCircleOutlined />,
      okText: "Cerrar Sesión",
      cancelText: "Cancelar",
      content: "Desea salir de 2bc ERP?",
      onOk() {
        firebase.auth().signOut();
        updateData({
          id: 0,
          nombre: "DESCONECTADO",
          pagina: "",
        });
        updateLogued(false);
        history.push("/");
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const opciones = [
    {
      key: "5",
      title: "Cambiar Password",
      icon: <Icon path={mdiLockReset} size={"26px"} color={colorPrm} />,
      onClick: () => openModal("Cambiar Password", 7, "500px"),
    },
    {
      key: "6",
      title: "Cerrar Sesion",
      icon: <Icon path={mdiLogout} size={"26px"} color={colorPrm} />,
      onClick: () => logOut(),
    },
  ];

  const ShowAlerts = (
    <form
      style={{
        backgroundColor: "#ffffff",
        marginTop: "5px",
        width: "350px",
        padding: "5px",
      }}
    >
      <div>
        <List
          style={{ marginTop: 5 }}
          itemLayout="horizontal"
          dataSource={opciones}
          renderItem={(item) => (
            <List.Item style={{ marginBottom: 3, marginTop: 3, padding: 2 }}>
              <List.Item.Meta
                avatar={item.icon}
                title={
                  <Title
                    level={4}
                    style={{
                      padding: 2,
                      margin: 2,
                      fontWeight: 300,
                      fontSize: 18,
                    }}
                  >
                    {item.title}
                  </Title>
                }
                onClick={item.onClick}
              />
            </List.Item>
          )}
        />
      </div>
    </form>
  );

  return (
    <>
      <Row className="main-header">
        <span style={{ left: "10px", position: "absolute", top: 10 }}>
          {userOptions.length > 0 ? (
            <Space size={"middle"}>
              <Button
                type="primary"
                className={curStyle.btnWhite}
                shape="circle"
                onClick={() => openDrawer(1, 1, "500px")}
                icon={<MenuOutlined style={{ color: colorPrm }} />}
              />
              <img src={logo_title} alt="Imagen" className="img-logo-title" />
            </Space>
          ) : (
            <img src={logo_title} alt="Imagen" className="img-logo-title" />
          )}
        </span>
        <span style={{ textAlign: "center", top: 10 }}>
          <Title level={4} style={{ color: colorPrm, marginTop: 10 }}>
            {titleHeader}
          </Title>
        </span>
        <span
          className="li-options"
          style={{
            textAlign: "right",
            right: "5px",
            top: 10,
            position: "absolute",
            width: "750px",
          }}
        >
          <Space size={"middle"}>
            <Badge count={5} style={{ backgroundColor: "orange" }}>
              <Button
                type="primary"
                className={curStyle.btnWhite}
                shape="circle"
                icon={<BellOutlined style={{ color: colorPrm }} />}
              />
            </Badge>
            <Badge count={5} style={{ backgroundColor: "#108ee9" }}>
              <Button
                type="primary"
                className={curStyle.btnWhite}
                shape="circle"
                icon={<MailOutlined style={{ color: colorPrm, size: 24 }} />}
              />
            </Badge>
            {currentUser.nombre}
            <Dropdown
              overlay={ShowAlerts}
              trigger={["click"]}
              placement="bottomLeft"
            >
              <Button
                type="primary"
                className={curStyle.btnSecundary}
                shape="circle"
                icon={<UserOutlined />}
              />
            </Dropdown>
          </Space>
        </span>
      </Row>
    </>
  );
}
